import Progress from 'redux-progress';
import * as actions from 'modules/checkout/contacts/duck/actions';

export default (state: Progress<any> = Progress.none, action: any) => {
  switch (action.type) {
    case actions.LOAD:
      return Progress.none;
    case actions.SUBMIT:
      return action.progress;
    default:
      return state;
  }
};
